import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=07510049&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=07510049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07510049",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07510049')) {
      api.createRecord('07510049', component.options)
    } else {
      api.reload('07510049', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=07510049&scoped=true&", function () {
      api.rerender('07510049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NnLtPyl7P2lR/JS/comp/SearchFilterTokens.vue"
export default component.exports